import BasicPage from './BasicPage'
import BasicLayout from './BasicLayout'
import BasicLogin from './Login'
import Profile from './Profile'

export {BasicLayout, BasicPage, BasicLogin, Profile}
